import {IFunctionContainer} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import {Function, Param} from '@mintdata/mint-kit/api/decorators/Function';
import {ISheetAPI, SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {BoxId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AString} from '@mintdata/mint-kit/api/values/AString';

export class DomFunctions implements IFunctionContainer
{
    public get namespace()
    {
        return 'dom';
    }

    @Function({
        title: 'SUBMIT_FORM(...)',
        alias: 'SUBMIT_FORM',
        lazyOnly: true,
        tip: 'Submit form in Iframe component',
        returns:
            {
                title: 'submit form',
                tip: 'Submit form in Iframe component',
                type: Type.Boolean
            }
    })
    public submitForm(@Param({
                          title: 'sheetAPI',
                          tip: 'API',
                          type: SheetType.SheetAPI
                      })
                          api:ISheetAPI,
                      @Param({
                          title: 'iframeName',
                          tip: 'Name of the Iframe component',
                          type: Type.String,
                      }) iframeName:AString,
                      @Param({
                          title: 'iframeName',
                          tip: 'ID of the Form in Iframe',
                          type: Type.String,
                      }) formId:AString,
                      @Param({
                          title: 'id/value',
                          tip: 'id/value',
                          type: Type.String,
                          repeatable: true,
                      }) args:AString[]):ABoolean
    {
        if( !iframeName || iframeName.isError
            || !formId || formId.isError
            || !args || args.length % 2 !== 0 )
            return ABoolean.false();

        const boxId:BoxId = api.getSurfaceContext().getBoxIdByName(iframeName.value);
        const frameEl:HTMLIFrameElement = document.querySelector(`div[data-box-id="${boxId}"] iframe`);

        if( frameEl && frameEl.contentDocument )
        {
            const formEl:HTMLFormElement = frameEl.contentDocument.querySelector(`[id=${formId.value}]`);
            const csrfEl:HTMLInputElement = frameEl.contentDocument.querySelector(`input[id=csrf_token]`);

            if( formEl )
            {
                for( let i = 0; i < args.length; i += 2 )
                {
                    const inputEl:HTMLInputElement = formEl.querySelector(`input[id=${args[i].value}]`);

                    if( inputEl )
                        inputEl.value = args[i + 1].value;
                    else
                        return ABoolean.false();
                }

                let csrfInputEl:HTMLInputElement = formEl.querySelector(`input[id=csrf_token]`);

                if( !csrfInputEl )
                {
                    csrfInputEl = frameEl.contentDocument.createElement('input');
                    csrfInputEl.id = 'csrf_token';
                    csrfInputEl.name = 'csrf_token';
                    csrfInputEl.type = 'hidden';

                    formEl.appendChild(csrfInputEl);
                }

                if( csrfEl && csrfInputEl )
                    csrfInputEl.value = csrfEl.value;

                formEl.submit();
            }
            else
                return ABoolean.false();
        }
        else
            return ABoolean.false();

        return ABoolean.true();
    }

    @Function({
        title: 'SEND_TO_PARENT(...)',
        alias: 'SEND_TO_PARENT',
        lazyOnly: true,
        tip: 'Sends Data to parent window',
        returns:
            {
                title: 'send data',
                tip: 'Sends Data to parent window to parent window',
                type: Type.Boolean
            }
    })
    public sendToParent(@Param({
        title: 'value',
        tip: 'Data to send',
        type: SheetType.AnyIValue
    }) value:IValue):ABoolean
    {
        if( !value || !window.parent || !window.parent.postMessage )
            return ABoolean.false();

        window.parent.postMessage(
            {
                messageType: 'SendDataToParent',
                type: value.getType().kind,
                data: value.toString()
            },
            '*'
        );

        return ABoolean.true();
    }
}
